/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConvertToPdfParams } from '../models/ConvertToPdfParams';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PdfService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Receive HTML and convert to a PDF
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public convertToPdf(
        requestBody?: ConvertToPdfParams,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/pdf/ConvertToPdf',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Retrieve a PDF we've created
     * @param fileGuid
     * @returns any OK
     * @throws ApiError
     */
    public getApiPdfGetPdf(
        fileGuid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/pdf/{fileGuid}/GetPdf',
            path: {
                'fileGuid': fileGuid,
            },
        });
    }
}
